/**
 * @function getHostname
 * Returns the hostname part of a given url
 *
 * @param {String} url - the URL to extract the hostname from.
 *
 * @returns {String}
 */
export default url => {
  // To align with the behavior of URL when a malformed url was passed.
  const error = new TypeError('Invalid URL');

  // This section is to feature detect for the URL constructor which doesn't exist in IE11.
  let hasWorkingUrl = false;
  try {
    const u = new URL('b', 'http://a');
    u.pathname = 'c%20d';
    hasWorkingUrl = u.href === 'http://a/c%20d';
  } catch (e) {
    // this comment is here to prevent an empty block statement from eslint.
  }

  if (hasWorkingUrl) {
    return new URL(url).hostname;
  } else if (document) {
    const a = document.createElement('a');
    a.href = url;

    // Weird IE issue that if the url points to URL consisting of a domain alone it'll add a '/' to it - even if the original URL didn't have it.
    // So if a.href equals to either one of these it's fine - otherwise throw an error.
    if (a.href !== url && a.href !== url + '/') {
      throw error;
    }

    // Normalizing the hostname - removing the port if it exists.
    // We can use "hostname" but according to MDN it isn't supported in IE.
    // With that said, MDN also states that "host" isn't supported by IE, but there's an asterisk - in IE9+ the "host" always returns the port even if it isn't supplied, which means it's safe for IE11.
    // host docs - https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/host#Browser_compatibility
    // hostname docs - https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/hostname#Browser_compatibility
    return a.host.replace(/:.*/, '');
  } else {
    // This regex tests for a URL (taken from here - https://stackoverflow.com/a/3809435)
    // The original regex also matches the path/query while we don't need this, just the hostname.
    const hostnameRegex = /https?:\/\/([-a-zA-Z0-9@:%._\+~#=]{2, 256}\.[a-z]{2,6})\b/i;
    const matchResult = url.match(hostnameRegex);

    if (!matchResult) {
      throw error;
    }

    return matchResult[1];
  }
};
